export enum ApplicationOrderingMode {
    AllProducts = "AllProducts",
    NextDayDelivery = "NextDayDelivery"
}